import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const tradeHistoryItemSchema = z.object({
  /** Symbol name */
  symbol: z.string(),
  /** Order ID */
  orderId: z.string(),
  /** User customized order ID. Classic spot is not supported */
  orderLinkId: z.string(),
  /** Side. Buy, Sell */
  side: z.string(),
  /** Order price */
  orderPrice: decimalSchema,
  /** Order quantity */
  orderQty: decimalSchema,
  /** The remaining quantity not executed. Classic spot is not supported */
  leavesQty: decimalSchema,
  /** Order create type. Not available for Spot, Option, or classic inverse */
  createType: z.string().optional(),
  /** Order type. Market, Limit */
  orderType: z.string(),
  /** Stop order type. If not stop order, returns UNKNOWN or "". Classic spot is not supported */
  stopOrderType: z.string().optional(),
  /** Executed trading fee */
  execFee: decimalSchema,
  /** Spot leg transaction fee. Only valid if execType = FutureSpread */
  execFeeV2: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** Execution ID */
  execId: z.string(),
  /** Execution price */
  execPrice: decimalSchema,
  /** Executed quantity */
  execQty: decimalSchema,
  /** Executed type. Classic spot is not supported */
  execType: z.string(),
  /** Executed order value. Classic spot is not supported */
  execValue: decimalSchema,
  /** Executed timestamp (ms) */
  execTime: z.string(),
  /** Spot trading fee currency. Classic spot is not supported */
  feeCurrency: z.string(),
  /** Whether the order was maker (true) or taker (false) */
  isMaker: z.boolean(),
  /** Trading fee rate. Classic spot is not supported */
  feeRate: decimalSchema,
  /** Implied volatility. Valid for option */
  tradeIv: z.string().optional(),
  /** Implied volatility of mark price. Valid for option */
  markIv: z.string().optional(),
  /** The mark price of the symbol when executing. Classic spot is not supported */
  markPrice: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** The index price of the symbol when executing. Valid for option only */
  indexPrice: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** The underlying price of the symbol when executing. Valid for option */
  underlyingPrice: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** Paradigm block trade ID */
  blockTradeId: z.string(),
  /** Closed position size */
  closedSize: z
    .union([decimalSchema, z.literal('').transform(() => undefined)])
    .optional(),
  /** Cross sequence for associating fills and position updates. Not present for Spot trade */
  seq: z.number().int().optional(),
  /** Additional fee info. Returned only under certain conditions (e.g., KYC, fiat orders) */
  extraFees: z.string().optional(),
})

export const responseSchema = z.object({
  /** レスポンスコード。0 は成功 */
  retCode: z.number(),
  /** レスポンスメッセージ */
  retMsg: z.string(),
  result: z.object({
    /** Product type */
    category: z.string(),
    /** Object */
    list: z.array(tradeHistoryItemSchema),
  }),
})
